import { motion } from "framer-motion"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import styled from "styled-components"
import BlankSlate from "../blank/BlankSlate"
import Fullscreen from "../fullscreen/Fullscreen"
import { media } from "../utils/styles"

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  justify-content: flex-start;
`

const DEFAULT_SUCCESS_BACKGROUND = { overlay: "rgba(0,0,0,.6)" }

const StyledSuccess = styled(motion.div)`
  max-width: min-content;
  min-width: 300px;
  margin-top: 100px;
  transform-origin: 50% 50%;

  > .BlankSlate {
    padding-left: 40px;
    padding-right: 40px;
  }

  ${media.max.phone`
    margin: 0;
    height: 100%;
    width: 100%;
    max-width: 100%;

    .BlankSlate {
      height: 100%;
    }
  `}
`

const Success = ({
  children,
  hideModal = true,
  background = DEFAULT_SUCCESS_BACKGROUND,
  onBackgroundClick,
  ...passProps
}) => {
  const [animated, setAnimated] = useState(false)
  // HACK ALERT: assumption is that any time the success screen is shown, we want to hide all modals
  useEffect(() => {
    if (hideModal) {
      const modalNodes = document.querySelectorAll(".Modal")
      if (modalNodes.length) {
        modalNodes.forEach((modalNode) => (modalNode.style.display = "none"))
      }
      return () => {
        if (modalNodes.length) {
          modalNodes.forEach((modalNode) => (modalNode.style.display = "block")) // assuming "block" is fine
        }
      }
    }
  }, [])

  return (
    <Fullscreen
      className="SuccessFullscreen"
      layer="success"
      background={background}
      onClickBackground={onBackgroundClick}
    >
      <StyledWrapper>
        <StyledSuccess
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          onAnimationComplete={() => setAnimated(true)}
        >
          <BlankSlate
            animateIcon
            inverted
            stack
            theme
            icons={null}
            {...passProps}
            // HACK ALERT: workaround for issue with LoadingCirle displaying as a gradient square, somehow related to the scale transform.
            // Stopgap fix is to prevent the LoadingCircle from beginning animation until Success component is done animating.
            primaryAction={
              animated ||
              (passProps.primaryAction && !passProps.primaryAction.submitting)
                ? passProps.primaryAction
                : null
            }
          >
            {children}
          </BlankSlate>
        </StyledSuccess>
      </StyledWrapper>
    </Fullscreen>
  )
}

Success.displayName = "Success"

Success.propTypes = {
  hideModal: PropTypes.bool,
  background: PropTypes.object
}

export default Success
